import { useContext } from 'react';
import MarketRegionStateComparisonOutput from '@app/model/market_area/MarketRegionStateComparisonOutput';
import {
	MarketAreaStateForMonthContext,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/provider/MarketAreaStateForMonthProvider';
import _isEmpty from 'lodash/isEmpty';


export const useMarketAreaStateForMonth = (): MarketRegionStateComparisonOutput[] | [] => useContext(MarketAreaStateForMonthContext);

export const useMarketAreaStateForStatDate = (statDate: string | undefined): MarketRegionStateComparisonOutput | undefined => {

	if(!statDate) return undefined;

	const outputs = useContext(MarketAreaStateForMonthContext);

	if (_isEmpty(outputs)) return undefined;

	return outputs.find(output => output.current.statDate === statDate);
};